import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import ReactDOM from "react-dom";

const ContactoComponent = () => {
    const {
        register,
        handleSubmit,
        reset,
        getValues,
        formState: { errors },
    } = useForm();

    const [respuestaServidor, setRespuestaServidor] = useState({
        icon: "",
        message: "",
        type: "",
    });
    const [showMessage, setShowMessage] = useState(false);
    const [formLoaded, setFormLoaded] = useState(false);
    const [btnText, setBtnText] = useState("ENVIAR MENSAJE");
    const [inputDisabled, setInputDisabled] = useState(false);

    const checkPhone = (phone) => {
        if (phone.length != 9) {
            return "El teléfono debe tener 9 digitos";
        }
        if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone)) {
            return "Debes ingresar un teléfono válido";
        }
    };

    const enviarDatos = (data) => {
        event.preventDefault();
        setBtnText("ENVIANDO...");
        setInputDisabled(true);
        axios
            .post(`/contacto/send`, data)
            .then((response) => {
                const data = response.data;
                setRespuestaServidor({
                    icon: "fa-check",
                    message: data.message,
                    type: "success",
                });
                reset();
            })
            .catch((error) => {
                console.log(error.response.data.message);
                setRespuestaServidor({
                    icon: "fa-times",
                    message: error.response.data.message,
                    type: "error",
                });

                setTimeout(() => {
                    setShowMessage(false);
                }, 5000);
            })
            .finally(() => {
                setInputDisabled(false);
                setShowMessage(true);
                setFormLoaded(true);
            });
    };

    return (
        <div>
            <div
                className={`form-box scrollanim-activate line-scrollanim-activate form-anim-activate ${
                    formLoaded ? "is-inview" : ""
                } ${showMessage ? "js-active" : ""}`}
                data-scroll
                data-scroll-offset="30%"
            >
                <div className="text-center">
                    <h3 className="headline-xxxxs anim-fade-to-top">
                        Sigamos en contacto
                    </h3>
                </div>
                <form name="formobrsv" onSubmit={handleSubmit(enviarDatos)}>
                    <div className="flex-container padding-top-60">
                        <div className="six-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <input
                                    type="text"
                                    name="nombre"
                                    id="nombre"
                                    className={`form-input js-pointer-small  ${
                                        errors.nombre ? "is-invalid" : ""
                                    }`}
                                    disabled={inputDisabled}
                                    {...register("nombre", {
                                        required: "Debes ingresar tu nombre",
                                    })}
                                />
                                <label
                                    htmlFor="nombre"
                                    className="form-label"
                                    data-text="Nombre"
                                >
                                    Nombre
                                </label>
                                <div className="anim-line-bottom"></div>
                            </div>
                            {errors.nombre && (
                                <div className="invalid-feedback">
                                    {errors.nombre.message}
                                </div>
                            )}
                        </div>

                        <div className="six-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <input
                                    type="text"
                                    name="apellido"
                                    id="apellido"
                                    className={`form-input js-pointer-small  ${
                                        errors.apellido ? "is-invalid" : ""
                                    }`}
                                    disabled={inputDisabled}
                                    {...register("apellido", {
                                        required: "Debes ingresar tu apellido",
                                    })}
                                />
                                <label
                                    htmlFor="apellido"
                                    className="form-label"
                                    data-text="Apellido"
                                >
                                    Apellido
                                </label>
                                <div className="anim-line-bottom"></div>
                            </div>
                            {errors.apellido && (
                                <div className="invalid-feedback">
                                    {errors.apellido.message}
                                </div>
                            )}
                        </div>

                        <div className="four-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    disabled={inputDisabled}
                                    className={`form-input js-pointer-small
                            ${errors.email ? "is-invalid" : ""}`}
                                    {...register("email", {
                                        required: "Debes ingresar tu email",
                                        pattern: {
                                            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message:
                                                "Debes ingresar un email válido",
                                        },
                                    })}
                                />
                                <label
                                    htmlFor="email"
                                    className="form-label tr-delay-02 email-label"
                                    data-text="Email "
                                >
                                    Email
                                </label>
                                <div className="anim-line-bottom tr-delay-02"></div>
                            </div>
                            {errors.email && (
                                <div className="invalid-feedback">
                                    {errors.email.message}
                                </div>
                            )}
                        </div>

                        <div className="four-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <input
                                    type="text"
                                    name="phone"
                                    id="phone"
                                    disabled={inputDisabled}
                                    className={`form-input js-pointer-small
                            ${errors.phone ? "is-invalid" : ""}`}
                                    {...register("phone", {
                                        required: "Debes ingresar tu telefono",
                                        validate: checkPhone,
                                    })}
                                />
                                <label
                                    htmlFor="phone"
                                    className="form-label tr-delay-02 fono-label"
                                    data-text="Teléfono"
                                >
                                    Teléfono
                                </label>
                                <div className="anim-line-bottom tr-delay-02"></div>
                            </div>
                            {errors.phone && (
                                <div className="invalid-feedback">
                                    {errors.phone.message}
                                </div>
                            )}
                        </div>

                        <div className="four-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <input
                                    type="text"
                                    name="empresa"
                                    id="empresa"
                                    disabled={inputDisabled}
                                    className={`form-input js-pointer-small
                            ${errors.phone ? "is-invalid" : ""}`}
                                    {...register("empresa", {
                                        required: "Debes ingresar tu empresa",
                                    })}
                                />
                                <label
                                    htmlFor="empresa"
                                    className="form-label tr-delay-02 empresa-label"
                                    data-text="Empresa"
                                >
                                    Empresa
                                </label>
                                <div className="anim-line-bottom tr-delay-02"></div>
                            </div>
                            {errors.empresa && (
                                <div className="invalid-feedback">
                                    {errors.empresa.message}
                                </div>
                            )}
                        </div>

                        <div className="twelve-columns padding-top-30">
                            <div className="column-l-r-margin-10 pos-rel">
                                <textarea
                                    className={`form-input js-pointer-small  ${
                                        getValues("mensaje") ? "empty" : ""
                                    }
                            ${errors.mensaje ? "is-invalid" : ""}`}
                                    name="mensaje"
                                    id="mensaje"
                                    disabled={inputDisabled}
                                    {...register("mensaje", {
                                        required: "Debes ingresar el mensaje",
                                    })}
                                ></textarea>

                                <label
                                    htmlFor="mensaje"
                                    className="form-label tr-delay-03"
                                    data-text="Mensaje"
                                >
                                    Mensaje
                                </label>
                                <div className="anim-line-bottom tr-delay-03"></div>
                            </div>
                            {errors.mensaje && (
                                <div className="invalid-feedback ">
                                    {errors.mensaje.message}
                                </div>
                            )}
                        </div>

                        <div className="twelve-columns padding-top-30">
                            <div className="padding-top-90 text-center">
                                <button
                                    type="submit"
                                    id="send"
                                    className={`border-btn js-pointer-large anim-fade-to-top tr-delay-06 ${
                                        showMessage ? "js-active" : ""
                                    }`}
                                >
                                    <span className="border-btn__inner">
                                        {btnText}
                                    </span>
                                    <span className="btn-wait">
                                        Enviando...
                                    </span>
                                    <span className="border-btn__lines-1"></span>
                                    <span className="border-btn__lines-2"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {respuestaServidor.message && (
                <div
                    className={`js-popup-fade ${
                        showMessage ? "js-active" : ""
                    } ${respuestaServidor.type}`}
                >
                    <div className="js-popup text-center">
                        <div className="popup-icon">
                            <i className={`fas ${respuestaServidor.icon}`}></i>
                        </div>
                        <div className="popup-alert headline-xs">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: respuestaServidor.message,
                                }}
                            ></span>
                        </div>
                        <div
                            className="flip-btn js-popup-close js-pointer-large"
                            onClick={() => setShowMessage(false)}
                        >
                            Cerrar
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContactoComponent;

// DOM element
if (document.getElementById("formulario-contacto")) {
    ReactDOM.render(
        <ContactoComponent />,
        document.getElementById("formulario-contacto")
    );
}
